import { render, staticRenderFns } from "./TicketEdit.vue?vue&type=template&id=683979b7&scoped=true&"
import script from "./TicketEdit.vue?vue&type=script&lang=js&"
export * from "./TicketEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683979b7",
  null
  
)

export default component.exports